export default __webpack_public_path__ + "17- woman water bottle-mobile-vertical.b549bdc6bc80c6aebf80.png";